import { useMemo, useState } from "react";
import { ProductCard } from "@/components/ProductCard";
import { useProducts } from "@/hooks/useProducts";

const SORTS = [
  { value: "terbaru", label: "Terbaru" },
  { value: "harga-asc", label: "Harga terendah" },
  { value: "harga-desc", label: "Harga tertinggi" },
  { value: "nama", label: "Nama A–Z" },
];

export default function Shop() {
  const { data: products = [], isLoading } = useProducts();
  const [collection, setCollection] = useState("semua");
  const [sort, setSort] = useState("terbaru");

  const collections = useMemo(
    () => ["semua", ...Array.from(new Set(products.map((p) => p.collection_name)))],
    [products]
  );

  const visible = useMemo(() => {
    let list =
      collection === "semua" ? [...products] : products.filter((p) => p.collection_name === collection);
    if (sort === "harga-asc") list.sort((a, b) => a.price - b.price);
    if (sort === "harga-desc") list.sort((a, b) => b.price - a.price);
    if (sort === "nama") list.sort((a, b) => a.name.localeCompare(b.name));
    return list;
  }, [products, collection, sort]);

  return (
    <div className="mx-auto max-w-[1440px] px-5 py-16 md:px-10 lg:px-16 lg:py-24" data-testid="shop-page">
      <p className="label-eyebrow text-sand">Katalog</p>
      <h1 className="mt-5 max-w-2xl font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl">
        Koleksi Gelang Beads
      </h1>
      <p className="mt-6 max-w-xl text-base leading-relaxed text-stone">
        Semua gelang dirangkai tangan. Website ini katalog — pemesanan diproses lewat WhatsApp.
      </p>

      <div className="mt-14 flex flex-col gap-6 border-y border-line py-5 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap gap-2" data-testid="collection-filters">
          {collections.map((c) => (
            <button
              key={c}
              onClick={() => setCollection(c)}
              className={`px-4 py-2 text-[11px] uppercase tracking-[0.16em] transition-colors duration-300 ${
                collection === c ? "bg-ink text-paper" : "text-stone hover:text-ink"
              }`}
              data-testid={`filter-${c.toLowerCase().replace(/\s/g, "-")}`}
            >
              {c === "semua" ? "Semua" : c}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <span className="text-[11px] uppercase tracking-[0.16em] text-stone">Urutkan</span>
          <select
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="border-b border-ink bg-transparent py-2 pr-6 text-sm text-ink outline-none"
            data-testid="sort-select"
          >
            {SORTS.map((s) => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <p className="mt-6 text-xs uppercase tracking-[0.16em] text-stone" data-testid="product-count">
        {visible.length} produk
      </p>

      <div className="mt-10 grid grid-cols-2 gap-x-6 gap-y-16 lg:grid-cols-4 lg:gap-x-8" data-testid="product-grid">
        {!isLoading && visible.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
      </div>
    </div>
  );
}
